import { loadStripe } from '@stripe/stripe-js'
import { env } from '@/infra/env'
import { memoize } from '@/utils/memoize-util'

// Importing anything from the Stripe library starts loading its scripts, so
// this module is only imported on demand.

const memoizedStripe = memoize(
  async () => {
    const key = env.STRIPE_PK
    if (!key) {
      throw new Error(
        'There is a missing Billing configuration. Please contact an administrator.',
      )
    }
    return loadStripe(key)
  },
  { promise: true },
)

/**
 * Gets the shared Stripe instance.
 */
export function getStripe() {
  return memoizedStripe()
}
